// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pg-1";
export var messageSideRight = "_pg-2";
export var subscribeToBackInStockBubbleContainer = "_pg-0";